import script from "./AppToastContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppToastContainer.vue?vue&type=script&setup=true&lang=ts"

import "./AppToastContainer.vue?vue&type=style&index=0&id=836d0baa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-836d0baa"]])

export default __exports__